const defaultOrigin = 'https://kkutu.io';

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function validatedHttpUrl(value: string, label: string): string {
  const parsed = new URL(value);
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    throw new Error(`${label} must use HTTP or HTTPS.`);
  }
  return stripTrailingSlash(parsed.toString());
}

const browserOrigin = typeof window === 'undefined' ? defaultOrigin : window.location.origin;

export const adminConfig = Object.freeze({
  apiOrigin: validatedHttpUrl(import.meta.env.VITE_API_ORIGIN || defaultOrigin, 'VITE_API_ORIGIN'),
  oauthIssuer: validatedHttpUrl(import.meta.env.VITE_OAUTH_ISSUER || defaultOrigin, 'VITE_OAUTH_ISSUER'),
  oauthClientId: import.meta.env.VITE_OAUTH_CLIENT_ID?.trim() || 'kkutuio-admin',
  oauthRedirectUri: validatedHttpUrl(
    import.meta.env.VITE_OAUTH_REDIRECT_URI || `${browserOrigin}/oauth/callback`,
    'VITE_OAUTH_REDIRECT_URI',
  ),
});
